export function isRequiredPropType(propType) {
  if (!propType) {
    return false;
  }
  return typeof propType === 'object' && propType.type && ['array', 'bool', 'func', 'number', 'object', 'string', 'node', 'element', 'any'].includes(propType.type);
}